// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriptionExternalIdModel {
    static getAttributeTypeMap() {
        return PrescriptionExternalIdModel.attributeTypeMap;
    }
}
PrescriptionExternalIdModel.discriminator = undefined;
PrescriptionExternalIdModel.attributeTypeMap = [
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    },
    {
        "name": "externalIdTypeId",
        "baseName": "externalIdTypeId",
        "type": "number"
    },
    {
        "name": "externalIdTypeCode",
        "baseName": "externalIdTypeCode",
        "type": "string"
    },
    {
        "name": "externalIdTypeDescription",
        "baseName": "externalIdTypeDescription",
        "type": "string"
    }
];
//# sourceMappingURL=prescriptionExternalIdModel.js.map